import { Badge, type BadgeProps } from "@wilco/ui";
import { t, type MessageKey } from "../i18n.ts";
import type { OrderState, PaymentStatus } from "./types.ts";

const PAYMENT: Record<PaymentStatus, { key: MessageKey; tone: BadgeProps["tone"] }> = {
  NOT_PAID: { key: "payment.NOT_PAID", tone: "neutral" },
  PARTIAL: { key: "payment.PARTIAL", tone: "warning" },
  PAID: { key: "payment.PAID", tone: "success" },
};

const STATE: Record<OrderState, { key: MessageKey; tone: BadgeProps["tone"] }> = {
  DRAFT: { key: "order.state.DRAFT", tone: "neutral" },
  AWAITING_APPROVAL: { key: "order.state.AWAITING_APPROVAL", tone: "warning" },
  CONFIRMED: { key: "order.state.CONFIRMED", tone: "strong" },
  CANCELLED: { key: "order.state.CANCELLED", tone: "neutral" },
};

export function PaymentBadge({ status }: { status: PaymentStatus }) {
  return <Badge tone={PAYMENT[status].tone}>{t(PAYMENT[status].key)}</Badge>;
}

export function StateBadge({ state }: { state: OrderState }) {
  return <Badge tone={STATE[state].tone}>{t(STATE[state].key)}</Badge>;
}
